import { useMemo } from "react";
import * as Sentry from "@sentry/react";
import {
  isInitialized,
  init,
  useSessionRecording,
} from "@deep-consulting-solutions/session-recording-s3";
import { useAuthStore } from "../store";
import { isInternalRenderPath } from "../lib/internalRenderBootstrap";

declare module "@deep-consulting-solutions/session-recording-s3" {
  interface SessionRecordingConfig {
    portal?: string;
  }
}

const LAMBDA_URL = process.env.REACT_APP_SESSION_RECORDING_LAMBDA_URL || "";
const API_KEY = process.env.REACT_APP_SESSION_RECORDING_API_KEY || "";

if (!isInternalRenderPath() && LAMBDA_URL && API_KEY && !isInitialized()) {
  init({
    lambdaUrl: LAMBDA_URL,
    apiKey: API_KEY,
    portal: "gcp-staff-portal",
    onError: (error: unknown) => {
      Sentry.captureException(error);
      // eslint-disable-next-line no-console
      console.error("[SessionRecording]", error);
    },
  });
}

export function useGcpSessionRecording() {
  const profile = useAuthStore((s) => s.profile);

  const userContext = useMemo(() => {
    if (!profile) return null;
    return {
      userId: profile.id,
      userEmail: profile.email,
      userName: profile.fullName || profile.username,
    };
  }, [profile]);

  return useSessionRecording({
    userContext,
    enabled: !!profile && isInitialized(),
  });
}
